import React from "react";

const createArray = (n) => Array.from({ length: n }, (_, i) => i + 1);

export const Pages = ({ page, setPage, length }) => {
  console.log("length", length);
  const numbers = createArray(length);
  return (
    <div className="container">
      <div className="collapse navbar-collapse" id="tab">
        <ul
          sx={{
            fontFamily: "'Cormorant Garamond', serif;",
          }}
          className="nav navbar-nav navbar-centre"
        >
          {numbers.map((n) => (
            <li key={n}>
              <button
                style={{
                  background: "none",
                  border: "none",
                  color: "#ac3b61",
                  fontWeight: 400,
                  cursor: "pointer",
                  position: "relative",
                  paddingBottom: "4px",
                  borderBottom:
                    page === n
                      ? "2px solid transparent" // Ensures space for underline
                      : "none",
                  backgroundImage:
                    page === n
                      ? "linear-gradient(to right, #ac3b61 0%, #cc698b 100%)"
                      : "none",
                  backgroundSize: "100% 2px",
                  backgroundPosition: "bottom",
                  backgroundRepeat: "no-repeat",
                }}
                checked={page === n}
                onClick={() => setPage(n)}
                onMouseOver={(e) => (e.target.style.textDecoration = "none")}
                onMouseOut={(e) => (e.target.style.textDecoration = "none")}
                className="page-scroll"
              >
                {n}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
